// Attack lunge: attacker briefly lurches toward target, then recoils.

import type { Animation } from "../../engine/animation/AnimationQueue";
import { Easing } from "../../engine/animation/Easing";
import { TIMING } from "../../config/constants";
import type { UnitVisual } from "../UnitVisual";

const MAX_LUNGE_PX = 22;

export class AttackAnim implements Animation {
  private elapsed = 0;
  private totalDuration = TIMING.attackLunge + TIMING.attackRecoil;
  private dx = 0;
  private dy = 0;

  constructor(
    private visual: UnitVisual,
    from: { x: number; y: number },
    to: { x: number; y: number },
  ) {
    const rawDx = to.x - from.x;
    const rawDy = to.y - from.y;
    const dist = Math.sqrt(rawDx * rawDx + rawDy * rawDy);
    const lunge = dist > 0 ? Math.min(dist * 0.4, MAX_LUNGE_PX) : 0;
    this.dx = dist > 0 ? (rawDx / dist) * lunge : 0;
    this.dy = dist > 0 ? (rawDy / dist) * lunge : 0;
  }

  update(dt: number): void {
    this.elapsed = Math.min(this.elapsed + dt, this.totalDuration);
    if (this.elapsed < TIMING.attackLunge) {
      const t = Easing.easeOutCubic(this.elapsed / TIMING.attackLunge);
      this.visual.lungeX = this.dx * t;
      this.visual.lungeY = this.dy * t;
    } else {
      const t = Easing.easeInOutQuad((this.elapsed - TIMING.attackLunge) / TIMING.attackRecoil);
      this.visual.lungeX = this.dx * (1 - t);
      this.visual.lungeY = this.dy * (1 - t);
    }
  }

  isDone(): boolean {
    return this.elapsed >= this.totalDuration;
  }

  onStart(): void {}

  onEnd(): void {
    this.visual.lungeX = 0;
    this.visual.lungeY = 0;
  }
}
